import React from 'react';
import { StyleProp, TextStyle, TouchableOpacity, ViewStyle } from 'react-native';
import { Hoverable } from 'react-native-web-hover';
import MyAppText from './MyAppText';

interface Props {
    text: string | React.ReactNode;
    textStyle?: StyleProp<TextStyle>;
    onPress?: () => void;
    style?: StyleProp<ViewStyle>;
}

export default function HoverableText({ text, textStyle, onPress, style }: Props) {
    return <TouchableOpacity onPress={onPress} style={style}>
        <Hoverable>
            {({ hovered }) => (
                <>
                    { typeof text === 'string'
                        ?
                        <MyAppText style={[textStyle, hovered && { textDecorationLine: 'underline' }]}>
                            {text}
                        </MyAppText>
                        : text }
                </>
            )}
        </Hoverable>
    </TouchableOpacity>;
}
